import Completed from "./images/completed.svg";
import PaymentFailed from "./images/payment-failed.svg";
import { paymentFailed, paymentPending, paymentSuccessful } from "./tracking";
import { ORDER_CATEGORY } from "../../../constants/my-orders-constants";
import { FORM_TYPE } from "../../../constants/app-constants";
import { appUrl } from "../../../constants/url-constants";

const origin = appUrl();
// const origin = "http://localhost:3000";

export const TRANSACTION_STATUS = {
    SUCCESS: "success",
    PENDING: "pending",
    FAILED: "failed"
};

export const ORDER_STATUS = {
    INITIATED: "INITIATED",
    PAYMENT_INITIATED: "PAYMENT_INITIATED",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
    SENT_FOR_FULFILLMENT: "SENT_FOR_FULFILLMENT",
    FULFILLMENT_PENDING: "FULFILLMENT_PENDING",
    FULFILLED: "FULFILLED",
    FULFILLMENT_UNSUCCESSFULL: "FULFILLMENT_UNSUCCESSFULL",
    REFUNDED: "REFUNDED",
    REFUND_PENDING: "REFUND_PENDING",
    PARTIALLY_FULFILLED: "PARTIALLY_FULFILLED",
    PLACED: "PLACED",
    REFUND_FAILED: "REFUND_FAILED"
};

export const STATUS_MAPPING = {
    [TRANSACTION_STATUS.SUCCESS]: {
        title: "Payment successful",
        subTitle: "Redirecting to order summary",
        icon: Completed,
        event: paymentSuccessful
    },
    [TRANSACTION_STATUS.PENDING]: {
        title: "Payment pending",
        subTitle: "Please don't close the screen. We are verifying your payment status",
        icon: PaymentFailed,
        event: paymentPending
    },
    [TRANSACTION_STATUS.FAILED]: {
        title: "Payment failed",
        subTitle: "Unfortunately, the payment has failed",
        icon: PaymentFailed,
        event: paymentFailed
    }
};

export const getOrderStatus = (status) => {
    if (status === ORDER_STATUS.INITIATED || status === ORDER_STATUS.PAYMENT_INITIATED || status === ORDER_STATUS.PAYMENT_PENDING) return TRANSACTION_STATUS.PENDING;
    if (status === ORDER_STATUS.PAYMENT_SUCCESS || status === ORDER_STATUS.SENT_FOR_FULFILLMENT) return TRANSACTION_STATUS.SUCCESS;
    return TRANSACTION_STATUS.FAILED;
};

export const ORDER_STATUS_MAPPING = {
    INITIATED: "Settlement Pending",
    FULFILLMENT_PENDING: "Settlement Pending",
    FULFILLED: "Settled",
    FULFILLMENT_UNSUCCESSFULL: "Failed",
    REFUND_PENDING: "Refund Initiated",
    REFUNDED: "Refunded"
};

export const EVENT_CATEGORY_MAP = {
    [ORDER_CATEGORY.SERVICE_HISTORY]: "Service_payment",
    [ORDER_CATEGORY.CAR_WASH]: "car_wash",
    [ORDER_CATEGORY.CAR_HEALTH_REPORT]: "chr_flow",
    [ORDER_CATEGORY.PRE_DELIVERY_INSPECTION]: "ppi_book_flow",
    [ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION]: "ppi_book_flow",
    [ORDER_CATEGORY.SELLER_PACKAGE]: "seller_packages"
};

export const FORM_TYPE_MAPPING = {
    [ORDER_CATEGORY.CAR_WASH]: FORM_TYPE.CAR_WASH,
    [ORDER_CATEGORY.CAR_HEALTH_REPORT]: FORM_TYPE.CAR_HEALTH,
    [ORDER_CATEGORY.PRE_DELIVERY_INSPECTION]: FORM_TYPE.PRE_DELIVERY_INSPECTION,
    [ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION]: FORM_TYPE.PRE_DELIVERY_INSPECTION,
    [ORDER_CATEGORY.SELLER_PACKAGE]: FORM_TYPE.C2B_SPOTLIGHT
};

export const CANCEL_URL_MAPPING = {
    [ORDER_CATEGORY.CAR_HEALTH_REPORT]: `${origin}/car-health/{token}`,
    [ORDER_CATEGORY.PRE_DELIVERY_INSPECTION]: `${origin}/pre-delivery-inspection/slot/{token}`,
    [ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION]: `${origin}/pre-delivery-inspection/slot/{token}`
};

export const SUCCESS_URL_MAPPING = {
    [ORDER_CATEGORY.CAR_WASH]: `${origin}/appointment/confirmation/?l={token}`,
    [ORDER_CATEGORY.PRE_DELIVERY_INSPECTION]: `${origin}/pre-delivery-inspection/confirmation/{token}`,
    [ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION]: `${origin}/pre-delivery-inspection/confirmation/{token}`,
    [ORDER_CATEGORY.SELLER_PACKAGE]: `${origin}/appointment/confirmation/?l={token}`
};

export const getSuccessUrl = ({token = "", orderNumber = "", orderCategory}) => {
    if (
        [
            ORDER_CATEGORY.CAR_WASH,
            ORDER_CATEGORY.PRE_DELIVERY_INSPECTION,
            ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION,
            ORDER_CATEGORY.SELLER_PACKAGE
        ].includes(orderCategory)) {
        return SUCCESS_URL_MAPPING[orderCategory].replace("{token}", token);
    } else {
        return `${origin}/order-summary/${orderNumber}`;
    }
};

export const getStatusDetails = ({status = "", orderCategory = ""}) => {
    if (status === TRANSACTION_STATUS.SUCCESS &&
        [ORDER_CATEGORY.PRE_DELIVERY_INSPECTION, ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION].includes(orderCategory)) {
        return {
            ...STATUS_MAPPING[status],
            subTitle: "Redirecting to appointment confirmation"
        };
    } else {
        return STATUS_MAPPING[status || TRANSACTION_STATUS.SUCCESS];
    }
};

export const VAS_ORDER_TERMINAL_STATES = [
    ORDER_STATUS.FULFILLED,
    ORDER_STATUS.REFUNDED,
    ORDER_STATUS.REFUND_PENDING
];
